import React, { useState, useEffect } from 'react';
import { Text, View, TouchableOpacity, Linking } from 'react-native';
import { Feather } from "@expo/vector-icons";
import AsyncStorage from '@react-native-async-storage/async-storage';
import api from '../../services/api';

import HeaderDefault from '../../components/HeaderDefault';
import HeaderInfoCoin from '../../components/HeaderInfoCoin';

import styles from "./styles";

const MoreInfosCoin = () => {
    const [dataCoin, setDataCoin] = useState([]);

    useEffect(() => {
        getDataCoin();
    }, []);

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        api.get(`/actives/${idCoin}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                console.log(res.data.files_actives)
                setDataCoin(res.data);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const openFile = async (path) => {
        let url = `https://filesgpx.s3.us-east-2.amazonaws.com/${path}`;
        const supported = await Linking.canOpenURL(url);
        if (supported) {
            await Linking.openURL(url);
        }
    }

    return (
        <>
            <HeaderDefault title={"MARKETPLACE"} />

            <View style={styles.container}>
                <HeaderInfoCoin dataCoin={dataCoin} />

                <View style={styles.hrLine}></View>

                <Text style={styles.titleDescription}>Descrição:</Text>

                <Text style={styles.contentDescription}>
                    {dataCoin.actives !== undefined ? dataCoin.actives[0].description : ''}
                </Text>
                {/* 
                <Text style={styles.titleDescription}>
                    {
                        dataCoin.actives !== undefined
                            ? dataCoin.actives[0].type_value === "Valor Fixo"
                                ? "Valor Fixo: " : "Valor mínimo: "
                            : ""
                    }
                </Text>
                <Text style={styles.valueCoin}>
                    {
                        dataCoin.actives !== undefined
                            ? dataCoin.actives[0].type_value === "Valor Fixo"
                                ? "GPX " + dataCoin.actives[0].single_value : "GPX " + dataCoin.actives[0].min_value_token
                            : ""
                    }
                </Text> */}

                <Text style={styles.titleDescriptionFiles}>Arquivos:</Text>

                {
                    dataCoin.files_actives !== undefined
                        ? dataCoin.files_actives.map((item, index) => (
                            <TouchableOpacity key={index} style={styles.contentFiles} onPress={() => { openFile(item.path) }}>
                                <Text>{item.name}</Text>
                                <Feather name="download" size={24} color="black" />
                            </TouchableOpacity>
                        )) : <></>
                }
            </View>
        </>
    );
}

export default MoreInfosCoin;